
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { DefaultValueAccessor } from '@angular/forms';

if (environment.production) {
  enableProdMode();
}

// Responsible for ensuring string inputs are trimmed globally
// for all form controls by overriding default behaviour
const original = DefaultValueAccessor.prototype.registerOnChange;

DefaultValueAccessor.prototype.registerOnChange = function (fn) {
  return original.call(this, value => {
    const trimmed = typeof value === 'string' ? value.trim() : value;
    return fn(trimmed);
  })
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => initSentry())
  .catch(err => console.error(err));

async function initSentry(): Promise<void> {
  const Sentry = await import('@sentry/angular-ivy');

  Sentry.init({
    dsn: "https://baec3f6319874a57bec66edc38fff978@o4505205529640960.ingest.sentry.io/4505209642287104",
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
      new Sentry.Replay(),
    ],
    tracesSampleRate: environment.production ? 0.1 : 0.01,
    tracePropagationTargets: ["localhost", /^https:\/\/gardiff-as-dev-eposapi.azurewebsites.net\/api/],
    replaysSessionSampleRate: environment.production ? 0.1 : 0.01,
    replaysOnErrorSampleRate: 0.01,
    environment: environment.description,
    ignoreErrors: [
      "Login Error", /^Failed$/
    ]
  });
}
